import { AccelerationNeedsScheduleRequest, IAccelerationNeedsScheduleResult } from '../serverApi/requests/AccelerationNeedsScheduleRequest';
import { DeleteDataAccelerationTasksRequest } from '../../ts/ServerApi/dataAcceleration/DeleteDataAccelerationTasksRequest';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { GetAccelerationTasksRequest } from '../../ts/ServerApi/requests/GetAccelerationTasksRequest';
import { IAccelerationTaskInfo } from '../../ts/models/IAccelerationTaskInfo';
import { IListResource } from '../../ts/resources/Resource';
import { IPromise } from 'angular';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { RunDataAccelerationTasksRequest } from '../../ts/ServerApi/dataAcceleration/RunDataAccelerationTasksRequest';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ServiceLocator } from '../../app/ServiceLocator';
import { SetDataAccelerationTasksScheduleRequest } from '../serverApi/requests/SetDataAccelerationTasksScheduleRequest';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';

class AccelerationTasksResource implements IListResource<IAccelerationTaskInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetAccelerationTasksRequest, ServerApiMapper.accelerationTasks);

  public all(): ResourceQuery<IAccelerationTaskInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public run(ids: string[]): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunDataAccelerationTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public del(ids: string[]): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteDataAccelerationTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public needsSchedule(ids: string[]): Promise<IAccelerationNeedsScheduleResult> {
    return WebHttpClient.sendRequest(new AccelerationNeedsScheduleRequest({targetIds: ids}));
  }

  public setSchedule(ids: string[], scheduleId: string) {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetDataAccelerationTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }
}

export const AccelerationTasks = new AccelerationTasksResource();


